import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import CommentsSideBar from '@components-clean/core/comments-side-bar';
import { RiskLogContext } from '@pages-clean/risk-assessment/risk-log/interfaces/context';
import { Permissions } from '@contexts/user-context';
import { useAuthorization } from '@hooks/index';
import Constants from '@utils/constants';

const RiskCommentsSideBar = () => {
    const { current } = useContext(RiskLogContext);
    const { t } = useTranslation('ram');
    const user = useAuthorization();
    const userHasWritePermission = !!user?.canWrite?.({
        module: Constants.Modules.RAM,
        element: Constants.DataElements.RiskAssessmentRiskLogComments,
        permission: Permissions.ReadWrite,
    });

    return (
        <CommentsSideBar
            studyId={current.study!.id}
            entityType="Risk"
            messageHubRelativeEndpoint="risk-hub"
            parentId={current.selectionState.selectedItem?.id}
            noParentSelectedMessage={t('riskLog.childAreas.info.noParentRecordSelected')}
            userHasWritePermission={userHasWritePermission}
        />
    );
};

export default RiskCommentsSideBar;
